import React from "react";
import { useAppState } from "../RetailerFitGuide_StateContext.jsx";
import { RetailerFitGuide_SolutionItem } from "./RetailerFitGuide_SolutionItem.jsx";
import { isValidSolutionType } from "../Script/RetailerFitGuide_Utils.js";
const RetailerFitGuide_Solutions = () => {

    const {
        selectedSolution,
        oldCarResult,
        translations,
    } = useAppState();

    const getGroupedRoofRackSolutions = () => {
        if (!oldCarResult?.solutions?.length > 0)
            return null;
        const roofRackSolutions = oldCarResult.solutions.filter(x => isValidSolutionType(x.solutionType));
        const availableRoofRackSolutions = roofRackSolutions?.filter(x => x.statusErp === "Sellable");
        const discontinuedRoofRackSolutions = roofRackSolutions?.filter(x => x.statusErp === "Discontinued");
        const sortedAvailableRoofRackSolutions = availableRoofRackSolutions.sort((a, b) => b.dataProductDisplayPriority - a.dataProductDisplayPriority);
        const sortedDiscontinuedRoofRackSolutions = discontinuedRoofRackSolutions.sort((a, b) => b.dataProductDisplayPriority - a.dataProductDisplayPriority);

        return {
            available: sortedAvailableRoofRackSolutions,
            discontinued: sortedDiscontinuedRoofRackSolutions
        }
    }

    const solutions = getGroupedRoofRackSolutions();

    return oldCarResult && !selectedSolution && <div className="retailerFitGuide_Solutions">
        <p className="heading4">{translations.selectCurrentSystem}</p>
        <ul className="list-unstyled">
            {solutions?.available?.length > 0 && solutions.available.map((solution, index) => <li key={index}>
                <RetailerFitGuide_SolutionItem solutionItem={solution} />
            </li>)}
            {oldCarResult && !solutions?.available?.length > 0 && <li className="paragraph">{translations.noAvailableSystems}.</li>}
        </ul>
        {solutions?.discontinued?.length > 0 && <div>
            <p className="heading4">{translations.discontinued}</p>
            <ul className="list-unstyled">
                {solutions.discontinued.map((solution, index) => <li key={index}>
                    <RetailerFitGuide_SolutionItem hideImage={true} solutionItem={solution} />
                </li>)}
            </ul>
        </div>}
    </div>
}

export default RetailerFitGuide_Solutions;